import { render, staticRenderFns } from "./Tech.vue?vue&type=template&id=33466830&scoped=true&"
import script from "./Tech.vue?vue&type=script&lang=js&"
export * from "./Tech.vue?vue&type=script&lang=js&"
import style0 from "./Tech.vue?vue&type=style&index=0&id=33466830&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33466830",
  null
  
)

export default component.exports